import React, { useState, useRef, useEffect } from "react";
import { ChevronDown, Eye, EyeOff, Building, Building2, LayoutList } from "lucide-react";
import "./dropDown.css";

const BookingSourceDropdown = ({ value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [expandedType, setExpandedType] = useState(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const emit = (val) => onChange({ target: { value: val } });

  const handleSelectAll = () => {
    emit("");
    setExpandedType(null);
    setIsOpen(false);
  };

  const handleToggleType = (type) => {
    if (expandedType === type) {
      setExpandedType(null);
    } else {
      setExpandedType(type);
      if (!(Array.isArray(value) && expandedType === type)) {
        emit(type);
      }
    }
  };

  const handleSelectSub = (type, sub) => {
    setExpandedType(type);
    if (Array.isArray(value) && value[0] === sub && expandedType === type) {
      emit(type);
    } else {
      emit([sub]);
    }
    setIsOpen(false);
  };

  const getLabel = () => {
    if (!value || value === "") return "All";
    if (value === "residential") return "Residential";
    if (value === "commercial") return "Commercial";
    if (Array.isArray(value)) {
      const parent = expandedType === "commercial" ? "Commercial" : "Residential";
      const sub = value[0] === "published" ? "Published" : "Unpublished";
      return `${parent} · ${sub}`;
    }
    return "All";
  };

  const isTypeActive = (type) =>
    value === type || (Array.isArray(value) && expandedType === type);

  const isSubActive = (type, sub) =>
    Array.isArray(value) && value[0] === sub && expandedType === type;

  return (
    <div className="pf-dd-wrapper" ref={wrapperRef}>
      <button
        className="pf-dd-trigger"
        onClick={() => setIsOpen((o) => !o)}
        aria-expanded={isOpen}
      >
        <span className="pf-dd-label">{getLabel()}</span>
        <ChevronDown
          size={16}
          className={`pf-dd-chevron ${isOpen ? "open" : ""}`}
        />
      </button>

      {isOpen && (
        <div className="pf-dd-menu">

          <button
            className={`pf-dd-item ${!value || value === "" ? "active" : ""}`}
            onClick={handleSelectAll}
          >
            <LayoutList size={15} />
            <span className="pf-dd-item-label">All</span>
            {(!value || value === "") && <span className="pf-dd-check">✓</span>}
          </button>

          <div className="pf-dd-divider" />

          <button
            className={`pf-dd-item ${isTypeActive("residential") ? "active" : ""}`}
            onClick={() => handleToggleType("residential")}
          >
            <Building size={15} />
            <span className="pf-dd-item-label">Residential</span>
            {isTypeActive("residential") && <span className="pf-dd-check">✓</span>}
            <ChevronDown
              size={13}
              className={`pf-dd-sub-chevron ${expandedType === "residential" ? "open" : ""}`}
            />
          </button>

          {expandedType === "residential" && (
            <div className="pf-dd-sub-group">
              <button
                className={`pf-dd-sub-item ${isSubActive("residential", "published") ? "active" : ""}`}
                onClick={() => handleSelectSub("residential", "published")}
              >
                <Eye size={13} />
                <span>Published</span>
                {isSubActive("residential", "published") && <span className="pf-dd-check">✓</span>}
              </button>
              <button
                className={`pf-dd-sub-item ${isSubActive("residential", "unpublished") ? "active" : ""}`}
                onClick={() => handleSelectSub("residential", "unpublished")}
              >
                <EyeOff size={13} />
                <span>Unpublished</span>
                {isSubActive("residential", "unpublished") && <span className="pf-dd-check">✓</span>}
              </button>
            </div>
          )}

          <div className="pf-dd-divider" />

          <button
            className={`pf-dd-item ${isTypeActive("commercial") ? "active" : ""}`}
            onClick={() => handleToggleType("commercial")}
          >
            <Building2 size={15} />
            <span className="pf-dd-item-label">Commercial</span>
            {isTypeActive("commercial") && <span className="pf-dd-check">✓</span>}
            <ChevronDown
              size={13}
              className={`pf-dd-sub-chevron ${expandedType === "commercial" ? "open" : ""}`}
            />
          </button>

          {expandedType === "commercial" && (
            <div className="pf-dd-sub-group">
              <button
                className={`pf-dd-sub-item ${isSubActive("commercial", "published") ? "active" : ""}`}
                onClick={() => handleSelectSub("commercial", "published")}
              >
                <Eye size={13} />
                <span>Published</span>
                {isSubActive("commercial", "published") && <span className="pf-dd-check">✓</span>}
              </button>
              <button
                className={`pf-dd-sub-item ${isSubActive("commercial", "unpublished") ? "active" : ""}`}
                onClick={() => handleSelectSub("commercial", "unpublished")}
              >
                <EyeOff size={13} />
                <span>Unpublished</span>
                {isSubActive("commercial", "unpublished") && <span className="pf-dd-check">✓</span>}
              </button>
            </div>
          )}

        </div>
      )}
    </div>
  );
};

export default BookingSourceDropdown;